import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
interface Props {
  isLoaded: boolean;
  isMounted: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AbSliderItem',
  props: {
    isLoaded: { type: Boolean },
    isMounted: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isLoaded: boolean;
  isMounted: boolean;
};



const loaded = computed(() => props.isLoaded);
const mounted = computed(() => props.isMounted);

return { __sfc: true,props, loaded, mounted }
}

})